
import { gql } from 'apollo-boost';

export const Q_INSURANCE_QUOTE = gql`
  query GaigInsuranceQuote($taskId: ID!) {
    insuranceQuote {
      insuranceQuoteByTaskId(taskId: $taskId) {
        entity {
          insuranceQuoteId
          vendorOpportunityId
          taskId
          insuranceProvider
          inputValue
          status
        }
      }
    }
  }
`;

export const Q_INSURANCE_QUOTE_BY_VENDOR_OPPORTUNITY_ID = gql`
  query GaigInsuranceQuoteByVendorOpportunityId($vendorOpportunityId: ID!) {
    insuranceQuote {
      insuranceQuoteByVOId(vendorOpportunityId: $vendorOpportunityId) {
        entity {
          insuranceQuoteId
          vendorOpportunityId
          taskId
          insuranceProvider
          inputValue
          status
          insuranceCoverage {
            coverageRequirements
            certificateRequirements
            otherInstructions
          }
        }
      }
    }
  }
`;

